import VerDetalleEmpleado from "components/empleados/VerDetalleEmpleado";
import React from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

const ViewVerDetalleEmpleado = () => {
  return (
    <>
      <Card>
        <CardHeader>Detalle del empleado:</CardHeader>
        <CardBody>
          <Row>
            <Col>
              <VerDetalleEmpleado></VerDetalleEmpleado>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default ViewVerDetalleEmpleado;
